import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ExperienceAIAdvisorService } from '../experience-ai-advisor.service';
import { ExperienceAIAdvisorPromptErrorsViewPart } from './prompt-errors/prompt-errors-view.part';
import { ExperienceAIAdvisorPromptResponsesViewPart } from './prompt-responses/prompt-responses-view.part';

@Component({
	selector: 'experience-ai-advisor-views-part',
	standalone: true,
	imports: [
		DroplistWidget,
		ExperienceAIAdvisorPromptResponsesViewPart,
		ExperienceAIAdvisorPromptErrorsViewPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './ai-advisor-views.part.html',
})
export class ExperienceAIAdvisorViewsPart implements OnInit {

	public service = inject(ExperienceAIAdvisorService);

	ngOnInit() {
		this.service.initializeUrl();
	}

}